import React from "react";

import { Jumbotron } from "./migration";

const RecentWork = ({ heading, subheading, items }) => {
  return (
    <Jumbotron
      fluid
      id="projects"
      className="m-0 text-white"
      style={{
        backgroundColor: "rgb(15, 18, 24)",
        backgroundImage:
          "radial-gradient(circle at 8% 20%, rgba(76, 201, 240, 0.14), transparent 30%), radial-gradient(circle at 90% 35%, rgba(244, 162, 97, 0.14), transparent 32%)",
      }}
    >
      <div className="container py-5">
        <h2 className="display-4 text-center mb-3">{heading}</h2>
        <p
          className="lead text-center mx-auto mb-5"
          style={{ maxWidth: "760px", color: "rgba(255, 255, 255, 0.84)" }}
        >
          {subheading}
        </p>

        <div className="row">
          {items.map((item, index) => (
            <div className="col-lg-4 mb-4" key={`${item.title}-${index}`}>
              <article
                className="h-100 rounded overflow-hidden"
                style={{
                  backgroundColor: "rgba(24, 28, 36, 0.92)",
                  border: "1px solid rgba(255, 255, 255, 0.14)",
                }}
              >
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  style={{ width: "100%", height: "210px", objectFit: "cover" }}
                />

                <div className="p-4">
                  <h3 className="h4 mb-1">{item.title}</h3>
                  <p
                    className="mb-3"
                    style={{
                      color: "rgba(255, 255, 255, 0.68)",
                      fontSize: "0.98rem",
                    }}
                  >
                    {item.subtitle}
                  </p>

                  <ul className="list-unstyled mb-0">
                    {item.highlights.map((point) => (
                      <li key={point} className="d-flex mb-2">
                        <i
                          className="fas fa-check-circle me-2"
                          style={{
                            color: "rgba(76, 201, 240, 0.92)",
                            marginTop: "0.25rem",
                          }}
                        />
                        <span style={{ color: "rgba(255, 255, 255, 0.82)" }}>
                          {point}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </Jumbotron>
  );
};

export default RecentWork;
